// extracted by mini-css-extract-plugin
module.exports = {"Faq":"Faq_Faq__Gsf66","List":"Faq_List__kYsJL","indicator":"Faq_indicator__QhLL6","answer":"Faq_answer__E9tmp"};